module.exports = __webpack_public_path__ + "static/media/20201114_124719_922_IMG_9965.4005e45b.jpg";